export default "__VITE_ASSET__DVkFtmPZ__"